import React, { useState } from 'react';
import { maintenanceRequest, readableError } from './maintenanceModel';

const fieldsFrom = issue => ({
  service: issue.service === 'unknown' ? '' : issue.service || '',
  component: issue.component || '',
  platform: issue.platform === 'unknown' ? '' : issue.platform || '',
  priority: issue.priority || 'P2',
  error_code: issue.error_code || ''
});

export default function TriageEditor({ issue, canEdit, onRefresh }) {
  const [draft, setDraft] = useState(null);
  const [expectedVersion, setExpectedVersion] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const isOpen = issue.status === 'OPEN';
  const change = key => event => setDraft(current => ({ ...current, [key]: event.target.value }));

  const begin = () => {
    setDraft(fieldsFrom(issue));
    setExpectedVersion(issue.version);
    setError('');
    setSaved(false);
  };
  const save = async event => {
    event.preventDefault();
    if (saving || !isOpen || !canEdit) return;
    setSaving(true); setError('');
    try {
      await maintenanceRequest('/triage', { body: {
        issue_id: issue.id, expected_version: expectedVersion,
        ...Object.fromEntries(Object.entries(draft).map(([key, value]) => [key, value.trim()]))
      } });
      setDraft(null); setSaved(true);
      await onRefresh();
    } catch (failure) {
      setError(readableError(failure));
      if (failure.status === 409) await onRefresh();
    } finally { setSaving(false); }
  };

  if (!canEdit || (!isOpen && !draft && !saved)) return null;
  return <section className="mq-triage" aria-label="문제 분류 수정">
    {!draft ? <div className="mq-triage-heading">
      {saved ? <span className="mq-text-green" role="status">분류를 수정했습니다.</span> : <span>담당 서비스와 실행 환경</span>}
      {isOpen && <button type="button" className="mq-button mq-small" onClick={begin}>분류 수정</button>}
    </div> : <form onSubmit={save}>
      <div className="mq-triage-heading"><strong>분류 수정</strong><small>접수된 문제의 담당 범위를 정합니다.</small></div>
      {error && <div className="mq-error" role="alert">{error}</div>}
      {!isOpen && <p className="mq-warning">현재 처리 상태에서는 분류를 수정할 수 없습니다. 입력한 내용은 보존했습니다.</p>}
      <div className="mq-form-grid">
        <label className="mq-field"><span>서비스 분류</span><input required maxLength={80} list="mq-triage-services" value={draft.service} onChange={change('service')} placeholder="예: agent-bridge" /><datalist id="mq-triage-services">{['agent-bridge', 'antstalk', 'antstown', 'antsmusic', 'store', 'skyscribe', 'edu', 'antsremote'].map(value => <option key={value} value={value} />)}</datalist></label>
        <label className="mq-field"><span>구성요소</span><input maxLength={100} value={draft.component} onChange={change('component')} placeholder="예: message-queue" /></label>
        <label className="mq-field"><span>실행 환경</span><select required value={draft.platform} onChange={change('platform')}><option value="">환경 선택</option>{['web', 'android', 'ios', 'desktop', 'server', 'bridge'].map(value => <option key={value}>{value}</option>)}{draft.platform && !['web', 'android', 'ios', 'desktop', 'server', 'bridge'].includes(draft.platform) && <option value={draft.platform}>{draft.platform}</option>}</select></label>
        <label className="mq-field"><span>분류 우선순위</span><select value={draft.priority} onChange={change('priority')}>{['P0', 'P1', 'P2', 'P3'].map(value => <option key={value}>{value}</option>)}</select></label>
        <label className="mq-field mq-field-wide"><span>관련 오류 코드</span><input maxLength={120} value={draft.error_code} onChange={change('error_code')} /></label>
      </div>
      <div className="mq-form-footer"><button type="button" className="mq-button mq-small" disabled={saving} onClick={() => { setDraft(null); setError(''); }}>취소</button><button type="submit" className="mq-button mq-primary mq-small" disabled={saving || !isOpen}>{saving ? '저장 중…' : '분류 저장'}</button></div>
    </form>}
  </section>;
}
